import { render, staticRenderFns } from "./ParsingSentencePartsSpeechPreview.vue?vue&type=template&id=766734eb&lang=pug&"
import script from "./ParsingSentencePartsSpeechPreview.vue?vue&type=script&lang=js&"
export * from "./ParsingSentencePartsSpeechPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports